/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FieldCheckboxV1Dto = {
  /**
   * UUID of the document the field belongs to
   */
  document_id: string;
  /**
   * ID of the field
   */
  id: string;
  /**
   * Name of the field
   */
  name?: string | null;
  /**
   * Page number the field is located on
   */
  page: number;
  /**
   * UUID of the signer the field is assigned to
   */
  signer_id: string;
  /**
   * Type of the field
   */
  type: FieldCheckboxV1Dto.type;
  /**
   * X coordinate of the field on the page in pixels
   */
  x: number;
  /**
   * X coordinate of the field on the page in pixels
   */
  y: number;
  /**
   * Whether the checkbox is checked
   */
  checked: boolean;
  /**
   * Whether the checkbox is optional
   */
  optional: boolean;
  /**
   * Size of the checkbox in pixels
   */
  size: number;
};
export namespace FieldCheckboxV1Dto {
  /**
   * Type of the field
   */
  export enum type {
    CHECKBOX = 'checkbox',
    MENTION = 'mention',
    RADIO_GROUP = 'radio_group',
    SIGNATURE = 'signature',
    TEXT = 'text',
  }
}
